export default "__VITE_ASSET__C8Zr_mB0__"